import * as React from 'react'
import type { SVGProps } from 'react'

function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 241.64 199.94"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="M228.46,199.94H13.18c-3.81,0-7.43-1.65-9.94-4.52-2.5-2.87-3.64-6.69-3.12-10.47L24.17,11.37c.9-6.48,6.51-11.37,13.06-11.37h168.91c6.61,0,12.23,4.94,13.07,11.5l22.33,173.58c.48,3.76-.67,7.54-3.18,10.39-2.5,2.84-6.11,4.47-9.89,4.47ZM37.23,5.1c-4.01,0-7.45,3-8.01,6.97L5.18,185.65c-.32,2.32.38,4.65,1.91,6.42,1.53,1.76,3.76,2.77,6.09,2.77h215.28c2.32,0,4.53-1,6.07-2.74,1.53-1.74,2.24-4.06,1.95-6.37L214.15,12.15c-.52-4.02-3.96-7.05-8.02-7.05H37.23Z" />
        <path d="M189.6,173.13c-1.32,0-2.44-1.02-2.54-2.36l-6.82-90.18c-.11-1.4.95-2.63,2.35-2.74,1.41-.11,2.63.95,2.74,2.35l6.82,90.18c.11,1.4-.95,2.63-2.35,2.74-.06,0-.13,0-.2,0Z" />
        <path d="M52.05,173.13c-.07,0-.14,0-.21,0-1.4-.11-2.45-1.35-2.33-2.75L61.3,25.69c.12-1.4,1.33-2.45,2.75-2.33,1.4.11,2.45,1.35,2.33,2.75l-11.8,144.69c-.11,1.33-1.23,2.34-2.54,2.34Z" />
        <path d="M133.02,42.62H49.05c-1.41,0-2.55-1.14-2.55-2.55s1.14-2.55,2.55-2.55h83.97c1.41,0,2.55,1.14,2.55,2.55s-1.14,2.55-2.55,2.55Z" />
        <path d="M120.82,97.73c-1.41,0-2.55-1.14-2.55-2.55V28.16c0-1.41,1.14-2.55,2.55-2.55s2.55,1.14,2.55,2.55v67.02c0,1.41-1.14,2.55-2.55,2.55Z" />
        <path d="M197.92,97.73h-77.1c-1.41,0-2.55-1.14-2.55-2.55s1.14-2.55,2.55-2.55h77.1c1.41,0,2.55,1.14,2.55,2.55s-1.14,2.55-2.55,2.55Z" />
        <path d="M203.49,158.28H38.16c-1.41,0-2.55-1.14-2.55-2.55s1.14-2.55,2.55-2.55h165.33c1.41,0,2.55,1.14,2.55,2.55s-1.14,2.55-2.55,2.55Z" />
        <path d="M97.04,129.72h-16.69c-1.41,0-2.55-1.14-2.55-2.55s1.14-2.55,2.55-2.55h16.69c1.41,0,2.55,1.14,2.55,2.55s-1.14,2.55-2.55,2.55Z" />
        <path d="M137.51,129.72h-16.69c-1.41,0-2.55-1.14-2.55-2.55s1.14-2.55,2.55-2.55h16.69c1.41,0,2.55,1.14,2.55,2.55s-1.14,2.55-2.55,2.55Z" />
      </g>
    </svg>
  )
}

export default Icon
